module.exports = __webpack_public_path__ + "static/assets/0c3b7f1bf70a6b8dba1e45e7e2e1eb2a.svg";